const routes = [
    {
        path: "/email/templates",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "emailtemplate_index"
        }
    }
];

export default routes;
